import React,{ useState } from 'react'
import CoursesTop from "./course-components/CoursesTop"
import SelectSchool from "./course-components/SelectSchool"
import SelectGrade from "./course-components/SelectGrade"
import Tables from "./course-components/Tables"


const Courses = ({school, setSchool}) => {

   
   const [grade, setGrade] = useState(3)

   return (
      <>
         <CoursesTop />
         <SelectSchool school={school} setSchool={setSchool} />
         <SelectGrade school={school} grade={grade} setGrade={setGrade} />
         <Tables school={school} grade={grade} />
      </>
   )
}


export default Courses